import { render, staticRenderFns } from "./InventoryOnHandForm.vue?vue&type=template&id=22ca2c59&"
import script from "./InventoryOnHandForm.vue?vue&type=script&lang=js&"
export * from "./InventoryOnHandForm.vue?vue&type=script&lang=js&"
import style0 from "./InventoryOnHandForm.vue?vue&type=style&index=0&id=22ca2c59&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports